import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiHome } from 'react-icons/fi';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
      }}
    >
      <div className="empty-state">
        <h1 style={{ fontSize: '72px', color: '#1a73e8' }}>404</h1>
        <h3>Page Not Found</h3>
        <p>The page you're looking for doesn't exist.</p>
        <button className="btn btn-primary" onClick={() => navigate('/dashboard')}>
          <FiHome size={18} />
          Back to Dashboard
        </button>
      </div>
    </div>
  );
};

export default NotFound;
